function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "iconCategoryTransactions");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Frame_-_24px"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}));

var SvgIconTransaction = function SvgIconTransaction(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, /*#__PURE__*/React.createElement("g", {
    id: "Academy-New-concept",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-130.000000, -621.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dooer-Academy-V2-Copy-2",
    transform: "translate(100.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(0.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-items",
    transform: "translate(0.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Not-expanded",
    transform: "translate(30.000000, 260.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-item",
    transform: "translate(0.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "banking-bill"
  }, _ref5, /*#__PURE__*/React.createElement("g", {
    id: "Filled_Icons",
    transform: "translate(3.333333, 1.666667)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999"
    },
    d: "M12.9375,0.125 C12.6916667,-0.0275 12.385,-0.0408333333 12.1266667,0.0866666667 L9.22666667,1.53916667 L7.12833333,0.14 C6.84833333,-0.0458333333 6.48416667,-0.0458333333 6.20416667,0.14 L4.10666667,1.53916667 L1.20666667,0.0866666667 C0.9475,-0.0408333333 0.640833333,-0.0275 0.395833333,0.125 C0.15,0.276666667 0,0.544166667 0,0.833333333 L0,15.8333333 C0,16.1233333 0.15,16.39 0.395833333,16.5433333 C0.529166667,16.6241667 0.680833333,16.6666667 0.833333333,16.6666667 C0.96,16.6666667 1.08916667,16.6375 1.20583333,16.5783333 L4.10583333,15.1283333 L6.20416667,16.5266667 C6.48416667,16.7133333 6.84833333,16.7133333 7.12833333,16.5266667 L9.22583333,15.1283333 L12.1266667,16.5783333 C12.385,16.7083333 12.6916667,16.6941667 12.9375,16.5433333 C13.1833333,16.39 13.3333333,16.1225 13.3333333,15.8333333 L13.3333333,0.833333333 C13.3333333,0.544166667 13.1833333,0.276666667 12.9375,0.125 Z M9.16666667,6.66666667 L6.25,6.66666667 C6.02083333,6.66666667 5.83333333,6.85333333 5.83333333,7.08333333 C5.83333333,7.31416667 6.02083333,7.5 6.25,7.5 L7.08333333,7.5 C8.2325,7.5 9.16666667,8.435 9.16666667,9.58333333 C9.16666667,10.59 8.45,11.4308333 7.5,11.625 L7.5,12.5 L5.83333333,12.5 L5.83333333,11.6666667 L4.16666667,11.6666667 L4.16666667,10 L7.08333333,10 C7.3125,10 7.5,9.81416667 7.5,9.58333333 C7.5,9.35333333 7.3125,9.16666667 7.08333333,9.16666667 L6.25,9.16666667 C5.10083333,9.16666667 4.16666667,8.23166667 4.16666667,7.08333333 C4.16666667,6.07666667 4.88333333,5.23583333 5.83333333,5.0425 L5.83333333,4.16583333 L7.5,4.16583333 L7.5,4.99916667 L9.16666667,4.99916667 L9.16666667,6.66666667 Z",
    id: "Shape"
  }))))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTransaction, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-transaction.e291ee6b.svg";
export { ForwardRef as ReactComponent };